import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="input-observer"
export default class extends Controller {
  static targets = ["status", "input"]
  static values = { saveIsRequired: { type: String, default: "Valeur modifiée ; cliquez sur Enregistrer" } }

  connect() {
    this.initialText = this.inputTarget.value;

    this.inputTarget.addEventListener("keyup", (event) => this.toggleStatus())
    this.toggleStatus()
  }

  toggleStatus() {
    if (this.initialText == this.inputTarget.value) {
      this.statusTarget.setAttribute("class", "glyphicon glyphicon-ok-circle ")
      this.statusTarget.title = "";
    } else {
      this.statusTarget.setAttribute("class", "glyphicon glyphicon-exclamation-sign")
      this.statusTarget.title = this.saveIsRequiredValue;
    }
  }
}
